<template>
  <div class="page">
    <a-row style="margin: 10px 0">
      <a-col :span="24">
        <!-- ✅ 使用 FormModel，并挂 rules -->
        <a-form-model ref="formRef" :model="form" :rules="rules">
          <!-- 标题 -->
          <div class="title">更新切换密码</div>

          <!-- 原密码 -->
          <a-form-model-item prop="oldPassword" style="margin-bottom: 10px">
            <a-input-password v-model="form.oldPassword" placeholder="请输入旧密码">
              <a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input-password>
          </a-form-model-item>

          <!-- 密码 -->
          <a-form-model-item prop="password" style="margin-bottom: 10px">
            <a-input-password v-model="form.password" placeholder="请输入新密码">
              <a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input-password>
          </a-form-model-item>

          <!-- 确认密码 -->
          <a-form-model-item prop="confirmPassword" style="margin-bottom: 10px">
            <a-input-password
              v-model="form.confirmPassword"
              placeholder="请再次输入新密码"
            >
              <a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input-password>
          </a-form-model-item>

          <!-- 更新按钮（仅点击触发） -->
          <a-form-model-item>
            <a-button
              style="width: 100%"
              size="large"
              type="primary"
              class="register-button"
              :loading="state.registerBtn"
              :disabled="state.registerBtn"
              @click="updatePassword"
            >
              更新
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {
  updateSwitchPassword,
} from "@/api/company/Company.js";
import { toBase64Utf8 } from "@/utils/base64";

export default {
  data() {
    return {
      // ✅ 用于 v-model 的表单数据
      form: {
        oldPassword:"",
        password: "",
        confirmPassword: "",
      },
      // ✅ 统一的 rules（触发你的原有方法）
      rules: {
        oldPassword: [{ required: true, message: "请输入旧密码！", trigger: "blur" }],
        password: [
          {
            validator: (rule, value, callback) =>
              this.validatePasswordComplexity(rule, value, callback),
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请确认新密码！", trigger: "blur" },
          {
            validator: (rule, value, callback) =>
              this.validateConfirmPassword(rule, value, callback),
            trigger: "blur",
          },
        ],
      },
      state: {
        registerBtn: false,
      },
    };
  },
  methods: {
    /** ✅ 密码复杂度校验 */
    validatePasswordComplexity(rule, value, callback) {
      if (!value) return callback("请输入新密码！");
      if (value === this.form.oldPassword) {
        return callback("新密码不能与旧密码相同！");
      }

      // 1️⃣ 长度校验
      if (value.length < 8 || value.length > 20) {
        return callback("密码长度需为 8-20 位！");
      }

      // 2️⃣ 必须包含大写、小写、数字、特殊符号
      const upper = /[A-Z]/;
      const lower = /[a-z]/;
      const digit = /[0-9]/;
      const special =
        /[~!@#$%^&*()_\-+=<>?{}[\]|:;"',./`￥！……（）—【】、；‘’，。《》？]/;

      if (
        !upper.test(value) ||
        !lower.test(value) ||
        !digit.test(value) ||
        !special.test(value)
      ) {
        return callback("密码需包含大写字母、小写字母、数字和特殊符号！");
      }

      return callback();
    },

    /** ✅ 确认密码一致性（原逻辑保留，rules 中调用它） */
    validateConfirmPassword(rule, value, callback) {
      if (value && value !== this.form.password) {
        callback("两次输入的密码不一致！");
      } else {
        callback();
      }
    },

    /** 注册提交：点击按钮触发（仅点击，不走回车提交） */
    updatePassword() {
      // 先整体验证（使用 rules）
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        this.state.registerBtn = true;
        updateSwitchPassword({
          oldPassword: toBase64Utf8(this.form.oldPassword),
          password: toBase64Utf8(this.form.password),
          confirmPassword: toBase64Utf8(this.form.confirmPassword),
        })
          .then((res) => {
            if (res && res.code === "200") {
              setTimeout(() => {
                this.$notification.success({
                  message: "企业切换密码修改成功",
                  description: res.msg || "新密码已生效",
                });
                this.state.registerBtn = false;
                this.form = {
                  oldPassword: "",
                  password: "",
                  confirmPassword: "",
                };
                this.$refs.formRef.resetFields();
                this.$emit("closePasswordMoudle");
              }, 1000);
            } else {
              setTimeout(() => {
                this.$notification.error({
                  message: "更新失败",
                  description: (res && res.msg) || "密码修改失败，请稍后重试",
                });
                this.state.registerBtn = false;
              }, 1000);
            }
          })
          .catch((err) => {
            this.state.registerBtn = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.page {
  max-width: 420px;
  margin: 0 auto;
}

.title {
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  color: #333;
  letter-spacing: 1px;
  margin-bottom: 24px;
  position: relative;
}

.register-button {
  border-radius: 4px;
  font-weight: 600;
  letter-spacing: 1px;
}


</style>
